import styled from 'styled-components';

export const Container = styled.div`
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
`;

export const GuideDashboardContainer = styled.div`
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
`;

export const GuideWelcome = styled.div`
    text-align: center;
    margin-bottom: 2rem;

    h1 {
        font-size: 2rem;
        color: #333;
        margin-bottom: 1rem;
    }

    p {
        color: #666;
        font-size: 1.1rem;
    }
`;

export const UpcomingTours = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
`;

export const TourCard = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;

    &:hover {
        transform: translateY(-2px);
    }

    h3 {
        color: #333;
        margin-bottom: 1rem;
    }

    p {
        color: #666;
        margin-bottom: 0.5rem;
    }

    .tour-details {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #eee;

        p {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.5rem;

            strong {
                color: #333;
            }
        }
    }
`;

export const NoToursMessage = styled.div`
    text-align: center;
    padding: 2rem;
    color: #666;
    font-size: 1.1rem;
    grid-column: 1 / -1;
`;

export const LoginButton = styled.button`
    background-color: #4CAF50;
    color: white;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    margin: 0.5rem 0;

    &:hover {
        opacity: 0.9;
    }
`;

export const ModalContainer = styled.div`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .modal-content {
        background-color: white;
        padding: 2rem;
        border-radius: 8px;
        width: 400px;
        max-width: 90%;

        h3 {
            margin-bottom: 1.5rem;
            color: #333;
        }

        .form-group {
            margin-bottom: 1rem;

            label {
                display: block;
                margin-bottom: 0.5rem;
                color: #666;
            }

            select {
                width: 100%;
                padding: 0.5rem;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 1rem;
            }
        }

        .button-group {
            display: flex;
            justify-content: flex-end;
            gap: 1rem;
            margin-top: 1.5rem;

            button {
                padding: 0.5rem 1rem;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 1rem;

                &:first-child {
                    background-color: #4CAF50;
                    color: white;
                }

                &:last-child {
                    background-color: #f44336;
                    color: white;
                }

                &:hover {
                    opacity: 0.9;
                }
            }
        }
    }
`;

export const Tab = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;

    div {
        padding: 0.5rem 1rem;
        cursor: pointer;
        border-radius: 4px;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f5f5f5;
        }

        &.selected {
            background-color: #4CAF50;
            color: white;
        }
    }
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

export const GuideList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;

    .guide-item {
        padding: 1rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            background-color: #f5f5f5;
        }

        &.selected {
            background-color: #4CAF50;
            color: white;
            border-color: #4CAF50;
        }
    }
`;

export const TourListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

export const TourItem = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const TourHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

export const TourId = styled.div`
    font-weight: bold;
    color: #333;
`;

export const BookingList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const BookingItem = styled.div`
    background-color: #f9f9f9;
    border-radius: 4px;
    padding: 1rem;
`;

export const BookingTitle = styled.h3`
    color: #333;
    margin-bottom: 0.5rem;
`;

export const BookingDetails = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.5rem;
`;

export const BookingDetail = styled.div`
    color: #666;
    font-size: 0.9rem;
`;

export const TourGuideList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
`;

export const GuideItem = styled.div`
    background-color: #e3f2fd;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #1976d2;
`;

export const AdminNavBar = styled.nav`
    background-color: #333;
    padding: 1rem;
    margin-bottom: 2rem;

    ul {
        display: flex;
        gap: 2rem;
        list-style: none;
        margin: 0;
        padding: 0;
    }

    a {
        color: white;
        text-decoration: none;
        font-size: 1.1rem;
        transition: color 0.3s;

        &:hover {
            color: #4CAF50;
        }

        &.active {
            color: #4CAF50;
            font-weight: bold;
        }
    }
`;

export const GuidesList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
`;

export const GuideCard = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;

    &:hover {
        transform: translateY(-2px);
    }

    h3 {
        color: #333;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    p {
        color: #666;
        margin-bottom: 0.5rem;
    }

    .guide-details {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #eee;

        p {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.5rem;

            strong {
                color: #333;
            }
        }
    }

    .status {
        display: inline-block;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        font-size: 0.8rem;
        font-weight: bold;

        &.active {
            background-color: #e8f5e9;
            color: #2e7d32;
        }

        &.inactive {
            background-color: #ffebee;
            color: #c62828;
        }
    }
`;
